import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { UtilCommonModule } from 'common/util/module'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale/module'

import { BackupAddDirModalComponent } from './components/backupAddDirModal.component'
import { RestoreAddModalComponent } from './components/restoreAddModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UtilCommonModule,
    EntityListModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    BackupAddDirModalComponent,
    RestoreAddModalComponent,
  ],
  exports: [
    BackupAddDirModalComponent,
    RestoreAddModalComponent,
  ],
})
export class TapeModule { }

export { BackupAddDirModalComponent, RestoreAddModalComponent }
